import { createFileRoute } from '@tanstack/react-router'
import { WorkOrderInfo } from 'pages/inventoryManagement/WorkOrderInfo'
import { z } from 'zod'

const workOrderSearchParams = z.object({
  mode: z.enum(['edit', 'create', 'view']).optional(),
})

export const Route = createFileRoute('/work-order/$workOrderID')({
  component: WorkOrderInfo,
  validateSearch: workOrderSearchParams,
  staticData: {
    title: 'Work Order',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
